// Core libs used on the public site (subscribe, cookie footer, CMS pages, Kommo form helpers).
// Page-specific heavy libs (intl-tel-input, etc.) belong in page entrypoints, not this global bundle.

window.jQuery = window.$ = require('jquery');

window.Swal = window.swal = require('sweetalert2/dist/sweetalert2.min.js');
require('@/src/js/vendors/plugins/sweetalert2.init.js');

window.axios = require('axios').default;
window.axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
};
